// extracted by mini-css-extract-plugin
export var body = "FeatureBlock-module--body--1869e";
export var image = "FeatureBlock-module--image--02fa6";
export var inner = "FeatureBlock-module--inner--acdcb";
export var isPrimary = "FeatureBlock-module--isPrimary--74a33";
export var isSecondary = "FeatureBlock-module--isSecondary--ab35c";